import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'
import styles from './ConfirmDiscardModal.module.css'

type ConfirmDiscardModalProps = {
  onConfirm: () => void
  onCancel:  () => void
  title?:        string
  message?:      string
  confirmLabel?: string
  cancelLabel?:  string
}

export function ConfirmDiscardModal({
  onConfirm,
  onCancel,
  title        = 'Descartar alterações?',
  message      = 'Você tem alterações não salvas na escalação. Copiar de outra liga vai descartá-las. Deseja continuar?',
  confirmLabel = 'Descartar e continuar',
  cancelLabel  = 'Cancelar',
}: ConfirmDiscardModalProps) {
  // ESC to cancel
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onCancel()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [onCancel])

  return (
    <>
      <div className={styles.backdrop} onClick={onCancel} aria-hidden="true" />

      <div
        className={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-discard-title"
      >
        <div className={styles.header}>
          <div className={styles.iconWrap} aria-hidden="true">
            <AlertTriangle size={18} strokeWidth={2.5} />
          </div>
          <h2 id="confirm-discard-title" className={styles.title}>
            {title}
          </h2>
        </div>

        <div className={styles.body}>
          <p className={styles.intro}>{message}</p>
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className={styles.confirmBtn} onClick={onConfirm} autoFocus>
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  )
}
